import React, { Component } from 'react';
import { connect } from 'react-redux';
import timeHelpers from '../../utils/timeHelpers.js';
import shared from '../../utils/shared.js';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { getFileType, videoType, dp } from '../../utils/shared';
import _ from 'lodash';
import sailsIOClient from 'sails.io.js';
import socketIOClient from 'socket.io-client';
import cfg from '../../../config.js'

const _videoStyle = {
  preload: 'auto',
  position: 'relative',
  minWidth: '100%',
  minHeight: '100%',
  width: '100%',
  height: '100%',
  loop: '',
  autoplay: "",
  muted: "",
  pointerEvents: "none"
}

class QuoteShort extends Component {
  constructor(props) {
    super(props);

    try {
      this._elementStates = [];
      this._elementsIntervals = [];
      this._elementIntervalMS = this.props.cycleTime;
  
      this.setupElements();
      let currentTimeInterval = timeHelpers.currentSeekTimeArray(this._elementsIntervals);
      let elementIndex = timeHelpers.indexFromIntervalArray(this._elementsIntervals);
      let timeIntervalRemainderMS = timeHelpers.timeIntervalRemainderArrayMS(this._elementsIntervals);
      this._intervalQuoteMS = 0;
  
      this._intervalTimeoutMS = timeIntervalRemainderMS;
  
      this.state = {
        elementIndex: elementIndex,
        secondsPassed: 0,
        showDebug: 0,
        quoteState: 0,
        currentTimeInterval: currentTimeInterval,
        showOverlay: true,
        showModal: false,
        showModalVideo: false,
      };

    } catch(e) {
      console.log(e);
    }
  }

  componentDidMount() {
    try {
      let socketsEnabled = _.get(cfg, 'sockets.enabled', false);
      if (socketsEnabled) {
        this.websocketHandler();
      }
      this.setupIntervalHandler();
      this.setupQuoteIndexHandler(); //rework to use the element index instead, becoase video will cycle with quotes.
      this.setVideoSeekTimeInterval();
      document.addEventListener("keydown", this.handleKeyDown);

    } catch(e) {
      console.log(e)
    }
  }

  handleImageLoaded = () => {
    if (this.state.showModal) {
      let height = this._imageModalRef.getBoundingClientRect().height;
      let width = this._imageModalRef.getBoundingClientRect().width;
      let offsetX = (this.props.screen.screenWidth / 2) - (width / 2);
      let offsetY = (this.props.screen.screenHeight / 2) - (height / 2);

      this._imageModalRef.style['left'] = offsetX + 'px';
      this._imageModalRef.style['top'] = offsetY + 'px';
    }
  }

  websocketHandler = () => {
    let displayId = this.props.content.id;
    this._io = sailsIOClient(socketIOClient);

    this._io.sails.autoConnect = true;
    this._io.sails.url = cfg.WEB_SERVER;
    
    this._io.socket.on('email_announcement', (event) => {
      // console.log("Event triggered");
      this.setupAsset(event);
    });
    
    this._io.socket.on('connect', () => {
      this._io.socket.get(`/feed/subscribe?display=${displayId}`, function serverResponded(body, JWR) {
        // console.log('loaded');
      });
    });

    this._io.socket.on('error', (e) => {
      // console.log('error');
    });

    this._io.socket.on('disconnect', () => {
      this._io.socket._raw.io._reconnection = true;
    });
  }

  setupAsset = (event) => {
    let data = JSON.parse(event);
    if (data.subject && this.props.content.settings.announcement_modules) {
      let module = _.find(this.props.content.settings.announcement_modules, { subject: data.subject });
      if (module) {
        let announcementModule = _.find(this.props.content.dm_active, { id: module.id });
        if (announcementModule) {
          let asset = _.get(announcementModule.contents, "images[0]", null);
          if (asset) {
            this._assetFile = asset.file_name;
            let announcementAudioAsset = _.get(announcementModule.contents, "images[1]", null);
            if (announcementAudioAsset) {
              this._audioAssetFile = announcementAudioAsset.file_name;
            }
  
            this._announcementAsset = shared.dp(this.props.screen, asset);
            this._announcementAudioAsset = shared.dp(this.props.screen, announcementAudioAsset);
            this._announcementTimeout = Number(announcementModule.contents.timeout) * 1000;
            
            let timeout = 0;
            if (data.schedule_for) {
              timeout = (Number(data.schedule_for) - Date.now());
            }
            if (timeout <= 0) {
              this.showModal();
            } else {
              setTimeout(() => {
                this.showModal();
              },timeout);
            }
          }
        }
      }
    }
  }

  showModal() {
    let fileType = getFileType(this._assetFile);
    if (fileType === "video") {
      if (!this.state.showModalVideo) {
        this.setState({
          showModalVideo: true
        });
      }
    } else {
      if (!this.state.showModal) {
        this.setState({
          showModal: true
        });

        this._modalCycle = setTimeout(() => {
          this.setState({
            showModal: false
          });
        }, this._announcementTimeout);
      }
    }

    // Check for the audio asset
    if (this._audioAssetFile) {
      let audioFileType = getFileType(this._audioAssetFile);
      // console.log("2.- Filetype", audioFileType);
      if (audioFileType === "audio") {
        if (!this.state.playAudio) {
          this.setState({
            playAudio: true
          });
        }
      }
    }
  }

  closeModal() {
    let fileType = getFileType(this._announcementAsset);
    if (fileType === "video") {
      if (this.state.showModalVideo) {
        this.setState({
          showModalVideo: false
        });
        clearTimeout(this._modalCycle);
      }
    } else {
      if (this.state.showModal) {
        this.setState({
          showModal: false
        });
        clearTimeout(this._modalCycle);
      }
    }
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "s":
        console.log(this.props);
        break;
      case "d":
        let newDebug = this.state.showDebug + 1
        if (newDebug > 2) {
          newDebug = 0
        }
        this.setState({
          showDebug: newDebug
        })
        break;
      default:
        break;
    }
  }

  setupElements() {
    try {
      let parentActive = {}
      let rootFolder = _.get(this.props.content, 'settings.selected_root_folder', null);
      if (rootFolder !== null) {
        rootFolder = Number(rootFolder);
        parentActive = _.find(this.props.content.story_categories, { id: rootFolder} );
      } else {
        parentActive = _.find(this.props.content.story_categories, (folder) => {
          let type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
          return type === "active";
        });
      }
      let storyBoardFolder = _.find(this.props.content.story_categories, (folder) => {
        let type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
        return (type === 'attract_loop_stories' && folder.parent_category === parentActive.id);
      });
      let modules = shared.getAllFolderModules(this.props.content.folder_modules, null, this.props.content.stories, storyBoardFolder.id);

      if (modules && modules.length > 0) {
        _.forEach(modules, (module, key) => {
          module = _.cloneDeep(module);
          let backgroundMediaName = _.get(module, 'contents.images[0].file_name', 'empty.png');
          let backgroundMedia = dp(this.props.screen, _.get(module, 'contents.images[0]', null));
          let backgroundType = getFileType(backgroundMediaName);

          if (!backgroundMedia) {
            console.log("No background has been found for this story");
          }

          let cycleTime = Number(_.get(module.contents.custom_fields, 'cycle_time.val', 60));
          let quoteCycleTime = Number(_.get(module.contents.custom_fields, 'cycle_time.val', 20));
          cycleTime *= 1000;
          quoteCycleTime *= 1000;
          this._elementsIntervals.push(cycleTime);
          let backgroundDropOpacity = _.has(module.contents, "custom_fields.short_quote_background_opacity.val") ? module.contents.custom_fields.short_quote_background_opacity.val * .01 : 0;

          let quote = [
            _.get(module.contents, 'headline', ""),
            _.get(module.contents, "custom_fields.short_quote_language_2.val", ""),
            _.get(module.contents, "custom_fields.short_quote_language_3.val", "")
          ]

          this._elementStates.push({
            storyType: _.get(module.contents.custom_fields, 'story_type.val.value', null),
            quotes: quote,
            quoteCycleTime: quoteCycleTime,
            cycleTime: cycleTime,
            backgroundMedia: backgroundMedia,
            backgroundMediaName: backgroundMediaName,
            backgroundDropOpacity: backgroundDropOpacity,
            backgroundType: backgroundType,
            overlayText: true,
            quoteOverlayOffsetDuration: 2,
            arrays: _.get(module.contents, 'arrays', {}),
            arraysValues: _.get(module.contents, 'arrays_values', {}),
            shortQuoteSettings: {
              backgroundColor: _.get(module.contents.custom_fields, "short_quote_background_color.val", "#FFFFFF"),
              quote: _.get(module.contents, "headline", ""),
              style: _.get(module.contents.custom_fields, "main_word_style", {}),
              checkerBoardStyle: _.get(module.contents.custom_fields, 'main_word_style', {})
            }
          })
        })
      }
    } catch(e) {
      console.log(e);
    }
  }

  setupIntervalHandler = () => {
    clearTimeout(this._intervalTimeout);
    this._intervalTimeout = null;
    this._intervalTimeout = setTimeout(() => {
      this._intervalTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._elementsIntervals);
      if (this._intervalTimeoutMS > 500) {
        let elementIndex = shared.loopIndex(this.state.elementIndex, 0, this._elementStates.length - 1, "forward");
        this.setState({
          elementIndex: elementIndex,
        });
      }

      this.setupIntervalHandler();
    }, this._intervalTimeoutMS);
  }

  setupQuoteIndexHandler = () => {
    clearTimeout(this._quoteIndexTimeout);
    this._quoteIndexTimeout = null;
    this._quoteIndexTimeout = setTimeout(() => {
      let quotes = this._elementStates[this.state.elementIndex].quotes;
      let pairLength = null;

      if (this._elementStates[this.state.elementIndex].storyType && this._elementStates[this.state.elementIndex].storyType === "slideshow") {
        let wordPairs = _.get(this._elementStates[this.state.elementIndex], 'arrays.words_pair', null);
        let wordsPairsValues = _.get(this._elementStates[this.state.elementIndex], 'arraysValues.words_pair', null);

        if (wordPairs) {
          pairLength = wordPairs.values.length;
          for (let i = 0; i < pairLength; i++) {
            wordPairs.values[i].main_word['value'] = _.get(wordsPairsValues, '['+i+'].main_word.val', null);
          }
          this._selectedWordIndex = timeHelpers.indexFromInterval(this._elementStates[this.state.elementIndex].quoteCycleTime, wordPairs.values.length);
          quotes[0] = wordPairs.values[this._selectedWordIndex].main_word.value;
        }
      }

      // These times are for the whole slide cycle.
      let timeIntervalRemainderMS = timeHelpers.timeIntervalRemainderArrayMS(this._elementsIntervals);
      let elementIntervalMS = this._elementStates[this.state.elementIndex].cycleTime;
      let currentMoment = elementIntervalMS - timeIntervalRemainderMS;
      let quoteOverlayOffsetDuration = this._elementStates[this.state.elementIndex]
        .quoteOverlayOffsetDuration * 1000;

      // Check current quote index based on duration of each of the quotes.
      // These times are for the Quote Cycle (Could be multiple quotes per Slide Cycle)
      let quoteCycleTime = this._elementStates[this.state.elementIndex].quoteCycleTime;
      let currentMomentInQuoteTransitionMS = currentMoment % quoteCycleTime;
      let timeQuoteRemainderMS = quoteCycleTime - currentMomentInQuoteTransitionMS;
      let currentQuoteIndex = Math.floor(currentMoment / quoteCycleTime) % quotes.length;
      if ((currentQuoteIndex + 1) > quotes.length) {
        currentQuoteIndex = 0;
      }

      if (timeIntervalRemainderMS > 500) {
        let nextIndex = this.state.elementIndex;
        if (timeIntervalRemainderMS <= timeQuoteRemainderMS - quoteOverlayOffsetDuration) {
          nextIndex = shared.loopIndex(this.state.elementIndex, 0, this._elementStates.length - 1, "forward");
        }
  
        if (this._elementStates[this.state.elementIndex].overlayText) {
          // Show when the video is starting
          if (currentMomentInQuoteTransitionMS >= quoteOverlayOffsetDuration && currentMomentInQuoteTransitionMS < (quoteCycleTime - quoteOverlayOffsetDuration)) {
            this._intervalQuoteMS = timeQuoteRemainderMS - quoteOverlayOffsetDuration;
            // console.log('showing at', currentMoment);
            this.setState({
              showOverlay: true,
              currentQuoteIndex: currentQuoteIndex
            });
            // Hide when the video is ending
          } else if (currentMomentInQuoteTransitionMS >= (quoteCycleTime - quoteOverlayOffsetDuration)) {
            // console.log('hiding at', currentMoment);
            this._intervalQuoteMS = timeQuoteRemainderMS + (this._elementStates[nextIndex].quoteOverlayOffsetDuration * 1000);
            this.setState({
              showOverlay: false,
              currentQuoteIndex: currentQuoteIndex
            });
          }
        } else {
          this.setState({
            showOverlay: false,
            currentQuoteIndex: currentQuoteIndex
          });
          this._intervalQuoteMS = timeIntervalRemainderMS + (this._elementStates[nextIndex].quoteOverlayOffsetDuration * 1000);
        }
      }

      this.setupQuoteIndexHandler();
    }, this._intervalQuoteMS);
  }

  setVideoSeekTimeInterval = () => {
    clearTimeout(this._intervalSeekTimeout);
    this._intervalSeekTimeout = null;
    this._intervalSeekTimeout = setTimeout(() => {
      let fileType = getFileType(this._elementStates[this.state.elementIndex].backgroundMedia);
      if (fileType === "video") {
        if (!this._currentVideoRef) {
          this.setVideoSeekTimeInterval();
        } else {
          this._currentVideoRef.currentTime = (this.state.currentTimeInterval / 1000);
          clearTimeout(this._intervalSeekTimeout);
        }
      }
    }, 30);
  }

  loadedMetadata = (event) => {
    let videoHeight = this._videoModalRef.getBoundingClientRect().height;
    let videoWidth = this._videoModalRef.getBoundingClientRect().width;
    let videoMaxHeight = 0;
    let videoMaxWidth = 0;
    let videoOffsetX = 0;
    let videoOffsetY = 0;
    let videoRatio = videoWidth / videoHeight;
    // let screenRatio = this.props.screen.screenWidth / this.props.screen.screenHeight;
    let isHorizontal = videoWidth > videoHeight;

    if (isHorizontal) {
      videoMaxWidth = this.props.screen.screenWidth;
      videoMaxHeight = videoMaxWidth / videoRatio;
    } else {
      videoMaxHeight = this.props.screen.screenHeight;
      videoMaxWidth = videoMaxHeight * videoRatio;
    }

    videoOffsetX = (videoMaxWidth < this.props.screen.screenWidth) ? (this.props.screen.screenWidth / 2) - (videoMaxWidth / 2) : 0;
    videoOffsetY = (videoMaxHeight < this.props.screen.screenHeight) ? (this.props.screen.screenHeight / 2) - (videoMaxHeight / 2) : 0;

    let videoControlsOffset = videoOffsetY + (videoHeight / 2);

    // console.log("Loaded Metadata");

    if (this._videoModalRef !== undefined && this._videoModalRef !== null) {
      let duration = this._videoModalRef.duration;
      // console.log("1- Setting a duration of", duration);
      this._modalCycle = setTimeout(() => {
        // console.log("Closing Modal");
        this.setState({
          showModalVideo: false
        });
      }, duration * 1000);
    } else {
      this.handleVideoDuration();
    }    

    this.setState({
      duration: event.target.duration,
      videoOffsetY: videoOffsetY,
      videoOffsetX: videoOffsetX,
      videoControlsOffset: videoControlsOffset,
      videoMaxHeight: videoMaxHeight,
      videoMaxWidth: videoMaxWidth,
      videoFile: this.props.content.file_path
    });
  }

  render() {
    try {
      let sectionWidth = this.props.screen.screenWidth;
      let sectionHeight = this.props.screen.screenHeight / 4;
  
      let imageDivStyle = {
        backgroundImage: "url(" + this._elementStates[this.state.elementIndex].backgroundMedia + ")",
        backgroundSize: "cover",
        position: "absolute",
        height: this.props.screen.screenHeight,
        width: this.props.screen.screenWidth,
        top: 0,
        left: 0,
        zIndex:9997
      }
  
      let quoteDivStyle = {
        backgroundColor: this._elementStates[this.state.elementIndex].shortQuoteSettings.backgroundColor,
        opacity: this._elementStates[this.state.elementIndex].backgroundDropOpacity,
        position: "absolute",
        height: sectionHeight,
        width: sectionWidth,
        // zIndex:9998
      }
  
      let cssStyle = {
        position: 'absolute',
        display: "table",
        height: sectionHeight,
        width: sectionWidth,
        // zIndex: 9999
      }
  
      let centeredDiv = {
        display: "table-cell",
        verticalAlign: "middle",
        textAlign: "center",
        paddingLeft: this.props.screen.screenWidth * 0.09,
        paddingRight: this.props.screen.screenWidth * 0.09,
      }

      const modalStyle = {
        position: 'absolute',
        height: this.props.screen.screenHeight,
        width: this.props.screen.screenWidth,
        zIndex: 9999
      }

      const _announcementVideoStyle = {
        preload: 'auto',
        position: 'absolute',
        muted: "",
        objectFit: "fill",
        width: this.state.videoMaxWidth,
        height: this.state.videoMaxHeight,
      }

      const _btnStyle = {
        color: 'white',
        position: 'absolute',
        fontSize: this.props.screen.screenHeight * 0.05,
        fontStyle: 'normal',
        fontWeight: 'bold',
        textDecoration: 'none',
        zIndex: 9999
      }

      let cType = "";
      if (this.state.showModalVideo) {
        cType = videoType(this._announcementAsset);
      }

      let spanQuoteTextStyle = {
        fontSize: this._elementStates[this.state.elementIndex].shortQuoteSettings.style.fontSize > 0 ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.fontSize * this.props.screen.screenHeight / 100 : this.props.screen.screenHeight * 0.026,
        fontStyle: ("font" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style) ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.fontStyle : "normal",
        textAlign: ("font" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style) ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.justification : "left",
        font: ("font" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style) ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.font : "Roboto",
        fontWeight: ("fontWeight" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style) ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.fontWeight : "bold",
        lineHeight: ("lineHeight" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style) ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.lineHeight + "%" : "185%",
        marginTop: ("height" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style) ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.height + "%" : "0%",
        display: this._elementStates[this.state.elementIndex].shortQuoteSettings.style.visible ? "block" : "none",
        color: _.get(this._elementStates[this.state.elementIndex].shortQuoteSettings.style, 'fontColor', "#000000"),
        zIndex:9999
      }
  
      let fileType =this._elementStates[this.state.elementIndex].backgroundType;
      let content = "";

      if (fileType === "video") {
        let cType = videoType(this._elementStates[this.state.elementIndex].backgroundMedia);
        content = (<div className="vid" style={{ position: 'absolute', top: 0, left: 0, width: "100%", maxWidth: "100%" }} key={this.state.elementIndex}>
          <video style={_videoStyle} ref={el => this._currentVideoRef = el} id="background-video" loop autoPlay muted>
            <source src={this._elementStates[this.state.elementIndex].backgroundMedia} type={cType} />
            Your browser does not support the video tag.
                  </video>
        </div>);
      } else {
        content = (<div style={{ ...imageDivStyle }} />);
      }
  
      let bezel = null;
      if (this.props.showBezel) {
        bezel = (
          <div style={{ position:"absolute", height:"100vh", background:"black", width:this.props.bezelSize, right:0, zIndex:9999 }}/>
        )
      }
  
      return (
        <div style={{ width:this.props.screen.screenWidth, height:this.props.screen.screenHeight, backgroundColor:"white", zIndex:-9999 }}>
          {bezel}
          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.elementIndex}>
              {content}
            </div>
            <div key={this.state.showOverlay}>
              {
                this.state.showOverlay ?
                  <div>
                    <div style={{ ...quoteDivStyle }}>
                    </div>
                    <div style={{ ...cssStyle }}>
                      <div style={{ ...centeredDiv }}>
                        <span style={{ ...spanQuoteTextStyle }}>{this._elementStates[this.state.elementIndex].quotes[this.state.currentQuoteIndex]}</span>
                      </div>
                    </div>
                  </div>
                  :
                  null
              }
            </div>
          </CSSTransitionGroup>

          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.showModal}>
              {
                this.state.showModal ?
                  <div style={{ ...modalStyle }}>
                    <a href="#" onClick={() => { this.closeModal() }} ref={el => this._closeModalRef = el} style={{ ..._btnStyle, top: this.state.closeModalBtnOffsetY, left: this.state.closeModalBtnOffsetX }}>X</a>
                    <img alt={"Announcement Modal"} style={{ position: 'absolute' }} src={this._announcementAsset} ref={el => this._imageModalRef = el} onLoad={this.handleImageLoaded.bind(this)} />
                  </div>
                  : null
              }
            </div>

            <div key={this.state.showModalVideo}>
              {
                this.state.showModalVideo ?
                  <div style={{ ...modalStyle, backgroundColor: "black" }}>
                    {/* <a href="#" onClick={() => { this.closeModal() }} ref={el => this._closeModalRef = el} style={{ ..._btnStyle, top: this.state.closeModalBtnOffsetY, left: this.state.closeModalBtnOffsetX }}>X</a> */}
                    <video style={{ ..._announcementVideoStyle, top: this.state.videoOffsetY, left: this.state.videoOffsetX }} ref={el => this._videoModalRef = el} onLoadedMetadata={this.loadedMetadata.bind(this)} autoPlay>
                      <source src={this._announcementAsset} type={cType} />
                      Your browser does not support the video tag.
                  </video>
                  </div>
                  : null
              }
            </div>
          </CSSTransitionGroup>
        </div>
      )

    } catch (e) {
      console.log(e);
      return (
        <div>{e}</div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  let cycleTime = 81000;
  let showBezel = shared.parseStringParam(window.location.href, "showBezel");
  let bezelSize = shared.parseStringParam(window.location.href, "bezelSize");

  if (_.has(state, 'content.settings.custom_vars.cycletime')) {
    cycleTime = Number(state.content.settings.custom_vars.cycletime);
  }

  if (!showBezel) {
    showBezel = false;
  }

  if (!bezelSize) {
    bezelSize = "17px";
  } else {
    bezelSize += "px";
  }

  return {
    screen: state.screen,
    content: state.content,
    cycleTime: cycleTime,
    showBezel: showBezel,
    bezelSize: bezelSize
    // element: this._elementStates[state.elementIndex],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteShort);


// WEBPACK FOOTER //
// ./src/Components/Quote/QuoteShort.js